<template>
  <div>

  <ValidationObserver ref="observer" v-slot="{ invalid }">

    <div class="flex flex-wrap -mx-2">
      <div class="w-full md:w-1/2 px-2">
        <div class="box">

          <model-select
            model="make"
            form-name="vehicle_make"
            data-vv-as="vehicle make"
            v-model="vehicle.make"
            label=""
            track-by=""
            :list.sync="list.make"
            :search-on-mount="true"
            :button-new="false"
            :button-edit="false"
            :is-loading="loading.make"
            @search="searchCarMake"
            @select="selectedMake"
            :is-taggable="!inModal"
            @create="createCarMake"
          ></model-select>

          <model-select
            class="mt-4"
            v-if="vehicle.make"
            model="model"
            form-name="vehicle_model"
            data-vv-as="vehicle model"
            v-model="vehicle.model"
            label=""
            trackBy=""
            :list.sync="list.model"
            :search-on-mount="true"
            :button-new="false"
            :button-edit="false"
            :is-loading="loading.model"
            @search="searchCarModel"
            @select="selectedMake"
            :is-taggable="!inModal"
            @create="createCarModel"
          ></model-select>


          <div class="flex flex-wrap -mx-2 mt-4">
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="plate-numbers">
                Plate numbers <span class="text-red-500">*</span>
              </label>

              <ValidationProvider
                rules="required"
                name="plate numbers"
                v-slot="{ errors }"
              >
                <input
                  name="plate_numbers"
                  type="text"
                  id="plate-numbers"
                  class="form-control"
                  v-model="vehicle.plate_numbers"
                  autocomplete="off"
                >
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="vin">
                VIN
              </label>
              <input
                name="vin"
                type="text"
                id="vin"
                class="form-control"
                v-model="vehicle.vin"
              >
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 mt-4">
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="odometer-reading">
                Odometer reading <span class="text-red-500">*</span>
              </label>
              <ValidationProvider
                rules="required|integer|max_value:2147483647"
                name="odometer reading"
                v-slot="{ errors }"
              >
                <input
                  name="odometer_reading"
                  type="text"
                  id="odometer-reading"
                  class="form-control"
                  v-model="vehicle.odometer_reading"
                  autocomplete="off"
                >
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="odometer-unit">
                Odometer unit
              </label>
              <div class="relative">
                <select
                  class="form-control pr-8"
                  id="odometer-unit"
                  v-model="vehicle.odometer_unit"
                >
                  <option :value="v.unit" v-for="(v, i) in config.speedUnits" :key="'speed-unit-options-' + i">{{ v.unit }}</option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center text-xs px-2">
                  <i class="fas fa-chevron-down"></i>
                </div>
              </div>
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 mt-4">
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="registration-date">
                Registration date
              </label>
              <flat-pickr
                v-model="registrationDate"
                :config="config.flatpickrConfig"
                class="form-control"
                placeholder="Select date"
                id="registration-date"
                name="registrationDate">
              </flat-pickr>
            </div>
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="manufacture-date">
                Manufacture date
              </label>
              <flat-pickr
                v-model="manufactureDate"
                :config="config.flatpickrConfig"
                class="form-control"
                placeholder="Select date"
                id="manufacture-date"
                name="manufactureDate">
              </flat-pickr>
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 mt-4">
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="model-year">
                Model year
              </label>

              <ValidationProvider
                rules="integer"
                name="model year"
                v-slot="{ errors }"
              >
                <input
                  name="model_year"
                  type="text"
                  id="model-year"
                  class="form-control"
                  v-model="vehicle.model_year"
                >
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="colour">
                Colour
              </label>
              <input
                name="colour"
                type="text"
                id="colour"
                class="form-control"
                v-model="vehicle.colour"
              >
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 mt-4">
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="fuel-type">
                Fuel type
              </label>
              <select class="form-control" id="fuel-type" v-model="vehicle.fuel">
                <option></option>
                <option :value="fuel" v-for="(fuel, i) in config.fuelTypes" :key="'fuel-' + i">{{ fuel }}</option>
              </select>
            </div>
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="door-plan">
                Door plan
              </label>
              <input
                name="door_plan"
                type="text"
                id="door-plan"
                class="form-control"
                v-model="vehicle.door_plan"
              >
            </div>
          </div>
        </div>
      </div>
      <div class="w-full md:w-1/2 px-2">
        <div class="box">

          <model-select
            model="customer"
            form-name="customer"
            v-model="vehicle.contact"
            :list.sync="customerList"
            :search-on-mount="true"
            :button-new="false"
            :button-edit="false"
            :is-taggable="!inModal"
            @search-completed="customerSearchCompleted"
          ></model-select>

          <p class="text-xl font-bold mt-4">ENGINE</p>
          <div class="flex flex-wrap -mx-2 mt-2">
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="gear-box">
                Gear box
              </label>
              <input
                name="gear_box"
                type="text"
                id="gear-box"
                class="form-control"
                v-model="vehicle.gear_box"
              >
            </div>
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="engine-size">
                Engine size
              </label>
              <input
                name="engine_size"
                type="text"
                id="engine-size"
                class="form-control"
                v-model="vehicle.engine_size"
              >
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 mt-4">
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="engine-number">
                Engine number
              </label>
              <input
                name="engine_number"
                type="text"
                id="engine-number"
                class="form-control"
                v-model="vehicle.engine_number"
              >
            </div>
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="power">
                Power
              </label>
              <input
                name="power"
                type="text"
                id="power"
                class="form-control"
                v-model="vehicle.power"
              >
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 mt-4">
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="co2-emission">
                CO2 emission
              </label>
              <input
                name="co2_emission"
                type="text"
                id="co2-emission"
                class="form-control"
                placeholder=""
                v-model="vehicle.co2_emission"
              >
            </div>
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="engine-hours">
                Engine hours
              </label>
              <input
                name="engine hours"
                type="text"
                id="co2-emission"
                class="form-control"
                placeholder=""
                v-model="vehicle.engine_hours"
              >
            </div>
          </div>

        </div>

        <div class="box flex flex-wrap justify-end items-center">
          <button
            type="button"
            class="btn btn-reset"
            @click="reset"
          >
            <i class="fa-xs fas fa-undo"></i>
            <span class="ml-1">RESET</span>
          </button>
          <button
            type="button"
            class="btn btn-save"
            @click="save"
          >
            <i class="fa-xs fas fa-check"></i>
            <span class="ml-2">{{ mode === 'edit' ? 'UPDATE' : 'SAVE' }}</span>
          </button>
        </div>

      </div>
    </div>

  </ValidationObserver>

  </div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'vehicle-edit',
  props: {
    vehicleID: {},
    createAlert: {
      type: Boolean,
      default: true,
    },
    inModal: Boolean,
  },
  data() {
    return {
      mode: null,
      editID: null,
      vehicle: {},
      list: {
        make: [],
        model: [],
      },
      customerList: [],
      editCustomerID: null,
      registrationDate: '',
      manufactureDate: '',
      loading: {
        make: false,
        model: false,
      },
      modal: {
        make: {
          active: false,
          title: '',
          value: null,
        },
        model: {
          active: false,
          title: '',
          value: null,
        },
      },
    }
  },
  watch: {
    vehicleID() {
      this.setMode()
    }
  },
  computed: {
    ...mapGetters({
      config: 'config/config',
    })
  },
  mounted() {
    if (!this.config.fuelTypes.length) {
      this['config/getFuelTypes']()
    }
    this.setMode()
    this.$EventBus.$on('vehicle.create.set', (vehicle) => this.setVehicleData(vehicle))
  },
  destroyed() {
    this.$EventBus.$off('vehicle.create.set')
  },
  methods: {
    setMode() {
      const name = this.$route.name.split('.')
      if (name[0] === 'vehicle' && name[1]) {
        this.mode = name[1]
      } else {
        this.mode = 'create'
      }

      if (this.vehicleID) {
        this.editID = this.vehicleID
        this.mode = 'edit'
      } else if (this.$route.params.vehicleID) {
        this.editID = this.$route.params.vehicleID
      }

      if (this.mode === 'create') {
        this.vehicle = this.emptyVehicle()
        // get car make
        this.searchCarMake('')
      } else {
        // get vehicle
        this.get()
        // get models for selected make
        this.searchCarModel('')
      }
    },
    selectedMake(make) {
      if (make !== this.vehicle.make) {
        this.vehicle.model = null
      }
      this.searchCarModel('')
    },
    createCarMake(tagName) {
      this.$swal.fire({
        title: 'Create car make',
        text: 'Make "' + tagName + '" doesn\'t exist. Do you want to create "' + tagName + '"?',
        type: 'question',
        confirmButtonText: 'OK',
        showCancelButton: true,
      })
        .then((result) => {
          if (result.value) {
            axios.post('vehicles/car/make', {
              make: tagName,
            })
              .then(() => {
                this.list.make.push(tagName)
                this.vehicle.make = tagName
                this.$swal.fire('Success', 'Car make "' + tagName + '" created successfully', 'success')
              })
          }
        })
    },
    createCarModel(tagName) {
      this.$swal.fire({
        title: 'Create car model',
        text: 'Model "' + tagName + '" doesn\'t exist. Do you want to create ' + this.vehicle.make + ' "' + tagName + '"?',
        type: 'question',
        confirmButtonText: 'OK',
        showCancelButton: true,
      })
        .then((result) => {
          if (result.value) {
            axios.post('vehicles/car/model', {make: this.vehicle.make, model: tagName})
              .then(() => {
                this.list.model.push(tagName)
                this.vehicle.model = tagName
                this.$swal.fire('Success', 'Car model "' + tagName + '" created successfully', 'success')
              })
          }
        })
    },
    get() {
      return new Promise((resolve, reject) => {
        axios.get('vehicles/' + this.editID)
          .then((response) => {
            const vehicle = response.data

            this.registrationDate = this.$moment(vehicle.registration_date, this.config.dateTimeFormats.api).format(this.config.dateFormats.display)
            this.manufactureDate = this.$moment(vehicle.manufacture_date, this.config.dateTimeFormats.api).format(this.config.dateFormats.display)

            this.vehicle = Object.assign({}, vehicle)

            // set customer
            const customer = this.vehicle.contact
            if (!customer) {
              this.$swal.fire('Customer not found', 'The customer assigned to this vehicle was most likely deleted. You must choose a new customer.', 'info')
            } else {
              const display_name = '#' + customer.id + ' ' + customer.first_name + ' ' + customer.last_name + (customer.company_name ? ' (' + customer.company_name + ')' : '')
              const newContact = {id: customer.id, display_name}
              this.customerList = []
              this.customerList.push(newContact)
              this.vehicle.contact = Object.assign({}, this.vehicle.contact, newContact)
            }

            resolve(vehicle)
          })
          .catch((error) => reject(error))
      })
    },
    reset() {
      this.$swal.fire({
        title: 'Reset Form',
        text: 'Are you sure?',
        type: 'question',
        confirmButtonText: 'Yes',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
      })
        .then((result) => {
          if (result.value) {
            if (this.mode === 'create') {
              this.vehicle = this.emptyVehicle()
            } else {
              this.get()
            }
          }
        })
    },
    async save () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        this.$notify({type: 'error', title: 'Form has errors'})
        return
      }
      this._save()
    },
    _save() {
      // set contact_id from vue-multiselect object
      this.vehicle.contact_id = this.vehicle.contact.id

      const regDate = this.$moment(this.registrationDate, this.config.dateFormats.display)
      const manDate = this.$moment(this.manufactureDate, this.config.dateFormats.display)
      if(regDate.isValid()) {
        this.vehicle.registration_date = regDate.format(this.config.dateTimeFormats.api)
      }
      if(manDate.isValid()) {
        this.vehicle.manufacture_date = manDate.format(this.config.dateTimeFormats.api)
      }

      // create / update
      if (this.mode === 'create') {
        axios.post('vehicles', this.vehicle)
          .then((response) => {
            const newVehicle = response.data
            this.$emit('created', newVehicle)

            if (this.createAlert) {
              this.$swal.fire({
                title: 'Done',
                text: 'Vehicle created successfully!',
                type: 'success',
                confirmButtonText: 'Show me',
                showCancelButton: true,
                cancelButtonText: 'Create more',
              })
                .then((result) => {
                  if (result.value) {
                    this.$router.push('/vehicle/details/' + newVehicle.id)
                  } else {
                    this.vehicle = Object.assign({}, this.emptyVehicle())
                  }
                })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      } else if (this.mode === 'edit') {
        axios.put('vehicles/' + this.vehicle.id, this.vehicle)
          .then(() => {
            this.$swal.fire({
              title: 'Done',
              text: 'Vehicle updated successfully!',
              type: 'success',
            })
            this.$emit('updated', this.vehicle)
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    customerSearchCompleted() {
      if (this.mode === 'create' && this.$route.params && this.$route.params.customerID) {
        this.vehicle.contact_id = this.$route.params.customerID
        axios.get('customers/' + this.vehicle.contact_id)
          .then(response => {
            this.vehicle.contact = response.data
            this.vehicle.contact.display_name = '#' + this.vehicle.contact.id + ' ' + this.vehicle.contact.first_name + ' ' + this.vehicle.contact.last_name + (this.vehicle.contact.company_name ? ' (' + this.vehicle.contact.company_name + ')' : '')
            this.customerList = []
            this.customerList.push({ id: this.vehicle.contact.id, display_name: this.vehicle.contact.display_name})
          })
      }
    },
    searchCarMake(query) {
      this.list.make = []
      this.loading.make = true
      axios.get('vehicles/car/make', {params: {query}})
        .then(response => {
          const makes = []
          for (let i in response.data) {
            makes.push(response.data[i].make)
          }
          this.list.make = makes
          this.loading.make = false
        })
        .catch(() => {
          this.loading.make = false
        })
    },
    searchCarModel(query) {
      this.list.model = []
      this.loading.model = true
      axios.get('vehicles/car/model', {params: {'make': this.vehicle.make, 'query': query}})
        .then(response => {
          const models = []
          for (let i in response.data) {
            models.push(response.data[i].model)
          }
          this.list.model = models
          this.loading.model = false
        })
        .catch(() => {
          this.loading.model = false
        })
    },
    setVehicleData(vehicle) {
      this.customerList = []
      this.customerList.push(vehicle.contact)
      this.vehicle.contact = Object.assign({}, this.vehicle.contact, vehicle.contact)
    },
    emptyVehicle() {
      return {
        contact_id: '',
        plate_numbers: '',
        make: '',
        model: '',
        model_year: '',
        vin: '',
        registration_date: '',
        manufacture_date: '',
        odometer_reading: '',
        odometer_unit: this.config.defaultSpeedUnit,
        colour: '',
        fuel: '',
        door_plan: '',
        gear_box: '',
        engine_size: '',
        engine_number: '',
        power: '',
        co2_emission: '',
      }
    },
    ...mapActions([
      'config/getFuelTypes',
    ])
  }
}
</script>
